import React from "react";
import { Lock, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function PlanGate({ feature, planRequired = "Growth", children, show = true }) {
  const navigate = useNavigate();
  if (!show) return null;
  return (
    <div className="rounded-2xl border border-border bg-card p-6 sm:p-10 text-center relative overflow-hidden" data-testid="plan-gate">
      <div className="absolute inset-0 operon-navy-band pointer-events-none" />
      <div className="relative">
        <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 text-primary px-3 py-1 text-xs font-medium">
          <Sparkles className="w-3.5 h-3.5" /> Available on {planRequired} plan
        </div>
        <h3 className="font-heading text-xl sm:text-2xl font-semibold mt-4">Unlock {feature}</h3>
        <p className="text-sm text-muted-foreground mt-2 max-w-md mx-auto">
          Upgrade your plan to enable {feature} and other advanced operations features.
        </p>
        <Button className="mt-5" onClick={() => navigate("/app/billing")} data-testid="plan-gate-upgrade-button">
          <Lock className="w-4 h-4 mr-2" /> View plans
        </Button>
        <div className="mt-6 opacity-40 blur-[1px] pointer-events-none">
          {children}
        </div>
      </div>
    </div>
  );
}

export function featureAllowedByPlan(plan, feature, subscriptionStatus) {
  // If the company is in a Stripe trial, treat them as Starter regardless of
  // the plan they selected at signup.
  if ((subscriptionStatus || "").toLowerCase() === "trialing") {
    plan = "starter";
  }
  const map = {
    free_trial: { production: false, bom: false, branding: false, multi_user: false, advanced_analytics: false, lot_tracking: false, api_access: false, multi_location: false, inventory_import: true },
    starter: { production: false, bom: false, branding: false, multi_user: false, advanced_analytics: false, lot_tracking: false, api_access: false, multi_location: false, inventory_import: true },
    growth: { production: true, bom: true, branding: true, multi_user: true, advanced_analytics: false, lot_tracking: true, api_access: false, multi_location: false, inventory_import: true },
    enterprise: { production: true, bom: true, branding: true, multi_user: true, advanced_analytics: true, lot_tracking: true, api_access: true, multi_location: true, inventory_import: true },
  };
  return !!map[plan]?.[feature];
}
